<template>
  <div>
    <pageHeader :dropdownData="reservationsColumns"
                :props="{ headerName: 'header', value: 'fieldName' }"
                :headerIcon="'folder open'"
                :headerText="$t('reservations')"
                :haveFilterInput="true"
                @filterString="filterStringEventListener"
                @columnName="columnNameEventListener"
                class="no-print"
                :columnsNumber="['five wide column', 'two wide column', 'nine wide column']"
                @startSearchingProcess="startSearchingProcessEventListener">
    </pageHeader>

    <div class="" style="padding-top: 25px;">
      <abstractTable :columns="reservationsColumns"
                      :useData="false"
                      :classes="'ui very compact center aligned celled table'"
                      :dataPerPage="25" :paginationEnable="true"
                      style="" :paginationNextButtonText="$t('next')"
                      :paginationPervButtonText="$t('previous')"
                      :paginationFirstPageButtonText="$t('first')"
                      :paginationLastPageButtonText="$t('last')"
                      :indexRoute="'reservations'"
                      :methodFormatter="computedReservations"
                      id="test"
                      :filters="filterStringBuilder"
                      @table-data="reservationsDataEventListenner"
                      @endSearchingProcess="endSearchingProcessEventListener"
                      :startSearchingFlag="startSearching"
                      :apiObjectName="'reservations'">
        <template slot="table-column">
          <th class="no-print"> {{ $t('actions') }} </th>
        </template>
        <template slot="table-row-after" slot-scope="props">
          <td class="no-print">
            <div class="ui blue tiny button"
                 style="background-color: #092442"
                 @click="goToReservation(props.row)">
              <!-- <i class="file icon"></i> -->
              Show
            </div>
            <div class="ui blue tiny button"
                 style="background-color: #092442"
                 v-if="!props.row.isCancelled && ($auth.check('employee') || isAdmin())"
                 @click="updateReservation(props.row)">
              <!-- <i class="file icon"></i> -->
              Update
            </div>
          </td>
        </template>
      </abstractTable>

      <div class="ui modal" id="new-transaction">
        <div class="header"> {{ $t('newTransaction') }} </div>
        <div class="content">
          <div class="ui form" id="reservation-transaction-form">
            <div class="two required fields">
              <div class="field">
                <label for="amount">{{ $t('amount') }}</label>
                <div class="ui input">
                  <input type="number"
                         :placeholder="$t('amount')" v-model="transaction.amount"
                         name="transactionAmount">
                </div>
              </div>

              <div class="field">
                <label for="paidAt">{{ $t('paidAt') }}</label>
                <div style="text-align: center" class="ui calendar" id="reservations-transaction-paid-at">
                  <div class="ui input left icon">
                    <i class="calendar icon"></i>
                    <input type="text" :placeholder="$t('paidAt')" readonly="" name="paidAt">
                  </div>
                </div>
              </div>
            </div>

            <div class="required field">
              <label for="description">{{ $t('description') }}</label>
                <textarea name="description"
                          :placeholder="$t('description')" rows="4"
                          v-model="transaction.description">
                </textarea>
              </label>
            </div>
          </div>
        </div>
        <div class="actions">
          <div class="ui button" @click="save()">{{ $t('save') }}</div>
          <div class="ui button" @click="closeModal()">{{ $t('cancel') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      transaction: {
        amount: null,
        description: null,
        paid_at: null
      },
      choosenReservation: null,
      filterString: '',
      columnName: 'all',
      startSearching: false,
      reservations: [],
      patients: [],
      doctors: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('.ui.dropdown').dropdown()
    })
  },
  computed: {
    filterStringBuilder () {
      let listOfFiltersNames = {
        id: 'id',
        issuer_name: 'user_id',
        patient_name: 'patient_id',
        doctor_name: 'doctor_id',
        patient_mobile: 'patient_id'
      }

      let filterableId = null

      if (this.columnName === 'patient_name') {
        filterableId = this.getPatient(this.filterString)
      } else if (this.columnName === 'patient_mobile') {
        filterableId = this.getPatientUsingMobile(this.filterString)
      } else if (this.columnName === 'doctor_name') {
        filterableId = this.getDoctor(this.filterString)
      } else {
        filterableId = this.filterString
      }

      return filterableId ?
        '&' + listOfFiltersNames[this.columnName] + '=' + filterableId : ''
    },
    reservationsColumns () {
      return [
        { header: this.$t('id'), fieldName: 'id', show: true, filterable: true },
        {
          header: 'Status',
          fieldName: 'status',
          show: false,
          filterable: false
        },
        {
          header: this.$t('issuedBy'),
          fieldName: 'issuer_name',
          show: true,
          html: this.$auth.check('doctor'),
          filterable: false
        },
        {
          header: this.$t('patientName'),
          fieldName: 'patient_name',
          show: true,
          html: true,
          filterable: true
        },
        { 
          header: this.$t('patientMobile'), 
          fieldName: 'patient_mobile', 
          show: this.$auth.check('employee') || this.isAdmin(), 
          filterable: this.$auth.check('employee') || this.isAdmin()
        },
        {
          header: 'clinic_id',
          fieldName: 'clinic_id',
          show: false,
          filterable: false
        },
        {
          header: 'Status',
          fieldName: 'isCancelled',
          show: false,
          filterable: false
        }
      ]
    }
  },
  methods: {
    computedReservations (reservationsObject) {
      let formlatedReservations = []
      window._.each(reservationsObject, reservation => {
        let doctor = reservation.doctor
        let patient = reservation.patient
        let user = reservation.user

        formlatedReservations.push({
          id: reservation.id,
          patient_mobile: patient.cell_phone,
          patient_name: {
            functionality: () => {
              this.navigateTo('Show_Patient', { key: 'params', value: { id: patient.id } })
            },
            value: `<a style="cursor: pointer;">${this.adjustName(patient.name)}</a>`,
            filteredValue: this.adjustName(patient.name)
          },
          issuer_name: {
            value: user.name,
            filteredValue: user.name
          },
          isCancelled: reservation.cancelled_at || false
        })
      })
      return formlatedReservations
    },
    filterStringEventListener (event) {
      this.filterString = event.data
    },
    columnNameEventListener (event) {
      this.columnName = event.data
    },
    startSearchingProcessEventListener (event) {
      this.startSearching = true
    },
    endSearchingProcessEventListener (event) {
      this.startSearching = false
    },
    columnInFilters (filterName) {
      return this.columnName === 'all' || this.columnName === filterName
    },
    openModal (reservation) {
      this.choosenReservation = reservation
      $('#new-transaction').modal('show').modal('refresh')
      this.initGui()
    },
    closeModal () {
      this.transaction.amount = null
      this.transaction.description = null
      $('#new-transaction').modal('hide')
      $('#reservation-transaction-form').form('reset')
    },
    save () {
      if ($('#reservation-transaction-form').form('is valid')) {
        this.$http.post(`reservations/${this.choosenReservation.id}/add/payment`, this.transaction).then(response => {
          this.closeModal()
        }).catch(errorResponse => {
          alert('there is a problem')
        })
      }
    },
    initGui () {
      this.$nextTick(() => {
        $('#reservations-transaction-paid-at').calendar({
          type: 'datetime',
          minDate: new Date(),
          onChange: (date) => {
            this.transaction.paid_at = date
          },
          isDisabled: (date, mode) => {
            return false
          }
        })

        $('#reservation-transaction-form').form({
          inline: true,
          on: 'blur',
          fields: {
            transactionAmount: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter the transaction amount.'
                },
                {
                  type: 'number',
                  prompt: 'Please enter a valid number.'
                }
              ]
            },
            paidAt: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Choose reservation date.'
                }
              ]
            },
            description: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Write description for this transaction.'
                }
              ]
            }
          }
        })
      })
    },
    getIssuer (reservation) {
      return reservation.user.profile
    },
    getIssuerType (reservation) {
      return reservation.user.role_name === 'employee' ? 'Employee' : 'Doctor'
    },
    reservationsDataEventListenner (event) {
      this.patients = event.data.map(reservation => reservation.patient)
      this.doctors = event.data.map(reservation => reservation.doctor)
    },
    getPatient (patientName) {
      let patient = window._.find(this.patients, patient => {
        return this.adjustName(patient.name).includes(patientName)
      })

      return (patient && patient.id) || null
    },
    getPatientUsingMobile (patientMobile) {
      let patient = window._.find(this.patients, patient => {
        return patient.cell_phone === patientMobile
      })
      return (patient && patient.id) || null
    },
    getDoctor (doctorName) {
      let doctor = window._.find(this.doctors, doctor => {
        return doctor.user.name.includes(doctorName)
      })

      return (doctor && doctor.id) || null
    },
    goToReservation (reservationRow) {
      this.navigateTo('Show_Reservation', {
        key: 'params',
        value: {
          id: reservationRow.id
        }
      })
    },
    updateReservation(reservationRow){
      this.navigateTo('Update_Reservation', {
        key: 'params',
        value: {
          id: reservationRow.id
        }
      })
    }
  },
  beforeDestroy () {
    $('#new-transaction').remove()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reservations/Reservations.vue